import { ShieldCheck, BatteryCharging, SlidersHorizontal } from "lucide-react";
import { SectionHead } from "@/components/site/SectionHead";
import { PhotoSlot } from "@/components/site/PhotoSlot";
import { QuoteButton } from "@/components/site/Cta";
import { Reveal } from "@/components/site/Reveal";
import { PHOTOS } from "@/content/site";

const POINTS = [
  { icon: BatteryCharging, t: "Store excess energy", d: "Capture solar energy your system produces for use later." },
  { icon: ShieldCheck, t: "Backup power", d: "Help keep selected circuits running during an outage." },
  { icon: SlidersHorizontal, t: "More control", d: "Choose how and when your home uses stored energy." },
];

export const Battery = ({ index = "05" }) => (
  <section id="batteries" data-testid="battery-section" className="grain relative overflow-hidden bg-[#050607] py-24 sm:py-32">
    <div className="pointer-events-none absolute left-1/2 top-1/2 h-[700px] w-[700px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-amber-500/10 blur-[140px]" />
    <div className="relative mx-auto grid max-w-[1440px] gap-14 px-5 sm:px-8 lg:grid-cols-12 lg:items-center lg:px-12">
      <div className="lg:col-span-6">
        <SectionHead index={index} eyebrow="Solar Batteries" lines={["Store your power.", "Take control of", "your energy."]}
          sub="Solar batteries can help store excess energy, provide backup power, and give homeowners greater control over how and when they use their energy." />
        <ul className="mt-10 space-y-3">
          {POINTS.map((p, i) => (
            <Reveal key={p.t} delay={i * 0.08} as="li" className="glass flex items-start gap-4 rounded-2xl p-5">
              <p.icon className="mt-0.5 h-5 w-5 shrink-0 text-amber-400" />
              <div><p className="text-sm font-semibold uppercase tracking-wide text-white">{p.t}</p><p className="mt-1 text-sm text-zinc-300">{p.d}</p></div>
            </Reveal>
          ))}
        </ul>
        <p className="mt-5 text-xs text-zinc-400">Battery performance and backup duration depend on equipment, system size and household usage.</p>
        <div className="mt-8"><QuoteButton service="Solar Battery" testId="battery-cta">Explore Battery Options</QuoteButton></div>
      </div>
      <Reveal className="lg:col-span-6 lg:pl-8">
        <div className="relative mx-auto max-w-md">
          <div className="absolute -inset-6 rounded-[40px] border border-white/5" />
          <PhotoSlot src={PHOTOS.battery} alt="Multiple Tesla Powerwall home batteries installed by Solar Energy Doc in Texas" label="Battery system" className="aspect-[2/3] rounded-[32px] border border-white/10" testId="battery-photo">
            {!PHOTOS.battery && (
              <div className="absolute inset-0 grid place-items-center">
                <div className="relative h-[62%] w-[46%] rounded-[22px] border border-white/20 bg-gradient-to-b from-zinc-100/90 to-zinc-300/80 shadow-[0_0_80px_-10px_rgba(245,166,35,0.55)]">
                  <div className="absolute inset-x-[18%] bottom-[12%] h-1 overflow-hidden rounded-full bg-black/20">
                    <div className="h-full w-2/3 bg-amber-400 sun-breathe" />
                  </div>
                </div>
              </div>
            )}
          </PhotoSlot>
        </div>
      </Reveal>
    </div>
  </section>
);
